import { useEffect, useState } from "react";
import axios from "axios";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import CircularProgress from "@mui/material/CircularProgress";
import { apiBaseUrl } from "../consts/api-url.const";

function decodeHtml(html: string) {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const Faq = () => {
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  
  const fetchData = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/faq`);
      const updatedFaqTab = response?.data?.faqTypeData;
      setSelectedCategory(updatedFaqTab);
      setLoading(false);

    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  if (loading || !selectedCategory || !selectedCategory[0]?.items) {
    return (
      <div className="min-h-[500px] flex items-center justify-center">
        <CircularProgress
          size={40}
          sx={{
            color: "#ffffff",
            display: "inline-flex",
            alignItems: "center",
            fontWeight: 900,
          }}
        />
      </div>
    );
  }
  return (
    <section className="faq-section md:pb-[140px] pb-[70px]">
      <div className="container">
        <div className="faq-content">
          <h2 className="text-5xl font-bold text-white text-center leading-[120%] mb-10">
            Faq
          </h2>
          <div className="sm:space-y-6">
            {selectedCategory[0]?.items?.map((faq: any, faqIndex: number) => (
              <Disclosure
                key={`faq_${faqIndex}`}
                as="div"
                className="py-4 sm:py-5 lg:py-7 sm:px-9 group flex flex-col sm:rounded-lg faq2-list text-white max-sm:border-b border-[#82879833]"
              >
                {({ open }) => (
                  <>
                    <DisclosureButton className="flex cursor-pointer items-center justify-between gap-2">
                      <span className="md:text-[22px] text-[18px] text-white text-left font-semibold">
                        {faqIndex + 1}. {decodeHtml(faq?.title)}
                      </span>
                      <span
                        className={`text-2xl sm:text-3xl font-light h-8 ${
                          open ? "hidden" : "inline-block"
                        }`}
                      >
                        +
                      </span>
                      <span
                        className={`text-2xl sm:text-3xl font-light h-8 ${
                          open ? "inline-block" : "hidden"
                        }`}
                      >
                        -
                      </span>
                    </DisclosureButton>
                    <DisclosurePanel className="transition duration-200 ease-out data-[closed]:-translate-y-4 data-[closed]:opacity-0 md:text-base text-sm text-[#FFFFFF99] mt-3">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: decodeHtml(faq?.description),
                        }}
                      />
                    </DisclosurePanel>
                  </>
                )}
              </Disclosure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
